import * as _ from 'lodash';
import moment from "moment-timezone"

const constants = require('./constants');

// 角色
export const OptsRole = _.map(constants.RoleValueMap,
    (v, k) => ({value: Number(k), label: v}));

export function getRoleTagInfo(role) {
    const Role = constants.Role;
    const tagMap = {
        [Role.YeWuYuan]: 'info',
        [Role.QiYe]: 'warning',
        [Role.Server]: 'danger',
        [Role.KeFu]: 'warning',
    }
    return {tag: tagMap[role] || 'info', label: constants.getRoleDesc(role)};
}

// 活跃状态
export function getActiveStateTagInfo(activeState) {
    const ActiveState = constants.ActiveState;
    const tagMap = {
        [ActiveState.Normal]: 'success',
        [ActiveState.Freeze]: 'warning',
        [ActiveState.Off]: 'danger'
    }
    return {tag: tagMap[activeState] || 'info', label: constants.getActiveStateDesc(activeState)};
}

// 支付方式
export const OptsPayType = _.map(constants.PayTypeValueMap,
    (v, k) => ({value: Number(k), label: v}));

// 销售渠道
export const OptsSaleChannel = _.map(constants.SaleChannelValueMap,
    (v, k) => ({value: Number(k), label: v}));

// 商品类型
export const OptsProductType = _.map(constants.ProductTypeValueMap,
    (v, k) => ({value: Number(k), label: v}));

// 商品子类型
export const OptsProductSubType = _.map(constants.ProductSubTypeValueMap,
    (v, k) => ({value: Number(k), label: v}));

// 销售主体
export const OptSaleEntity = _.map(constants.SaleEntityValueMap,
    (v, k) => ({value: k, label: v}));
export const getSaleEntity = (row, column, cellValue, index) => {
    const {name} = constants.getSaleEntity(cellValue);
    return name
}

// 支付状态
export const OptsPaymentState = _.map(constants.PaymentStateValueMap,
    (v, k) => ({value: Number(k), label: v}));

export function getPaymentStateTagInfo(state) {
    const PaymentState = constants.PaymentState;
    const label = constants.getPaymentStateDesc(state) || "未知";
    switch (state) {
        case PaymentState.Created:
        case PaymentState.Pending:
        case PaymentState.ToBePaid:
            return {tag: 'warning', label}
        case PaymentState.Finish:
            return {tag: 'success', label}
        case PaymentState.Refund:
            return {tag: 'info', label}
        case PaymentState.Expired:
        case PaymentState.None:
            return {tag: '', label}
        case PaymentState.RefundPending:
        case PaymentState.Paid:
        case PaymentState.SurrenderedAndWaitForRefund:
        case PaymentState.RefundedAndWaitForSurrender:
            return {tag: 'danger', label}
        default:
            return {tag: 'danger', label}
    }
}

// 国家
export const OptsCountryCode = _.map(constants.countryCode,
    (v, k) => ({value: k, label: v}));

// 生效规则
export const OptsEffectRules = _.map(constants.EffectRulesValueMap,
    (v, k) => ({value: Number(k), label: v}));

// 返回指定的opts列表
export function getOptsList(opts, val) {
    return opts.filter(opt => (val & opt.value) === opt.value);
}

// 服务器api host
export function getHost() {
    return process.env.VUE_APP_API_URL;
}

// oss host
export function getImageUrl() {
    return process.env.VUE_APP_STORAGE_LOCATION;
}

const defaultTimeZone = constants.defaultTimeZone;
// 日历
export const pickerOptions = {

    shortcuts: [
        {
            text: '当天',
            onClick(picker) {
                const start = moment("0", "hh").tz(defaultTimeZone);
                const end = moment("0", "hh").tz(defaultTimeZone).add(1, 'day');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '本月',
            onClick(picker) {
                const start = moment().tz(defaultTimeZone).startOf('month');
                const end = moment("0", "hh").tz(defaultTimeZone).add(1, 'day');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '上个月',
            onClick(picker) {
                const start = moment().tz(defaultTimeZone).subtract(1, 'month').startOf('month');
                const end = moment().tz(defaultTimeZone).subtract(1, 'month').endOf('month');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '本年',
            onClick(picker) {
                const start = moment().tz(defaultTimeZone).startOf('year');
                const end = moment("0", "hh").tz(defaultTimeZone).add(1, 'day');
                picker.$emit('pick', [start, end]);
            }
        }
    ]
}

// 下载
export function parseDownloadResponse(res, fileName) {
    // 重定向
    if (res.redirect) {
        window.open(res.redirect, '_blank');
        // 或弹窗提示正在跳转等
        return;
    }
    // 下载文件
    const disposition = res.headers && res.headers['content-disposition'];
    if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match) fileName = decodeURIComponent(match[1]);
    }
    const blob = new Blob([res.data], {type: res.headers['content-type'] || 'application/pdf'});
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url); // 释放
}